export const TASK_STATUSES = ['QUEUED', 'IN_PROGRESS', 'IN_REVIEW', 'COMPLETED', 'CANCELLED', 'FAILED'];
export const TASK_SOURCES = ['github', 'slack', 'manual', 'scheduled'];
export const TASK_MODELS = ['none', 'sonnet', 'opus', 'haiku', 'glm'];
/** Display labels for the model vocabulary — shared by the Task and Agent sidebars so a
 * model never appears under different names in the two. Unknown ids fall back to the raw
 * id (shown as an extra select option so a stored value never renders blank). */
export const MODEL_LABELS = {
    none: 'None',
    sonnet: 'Sonnet',
    opus: 'Opus',
    haiku: 'Haiku',
    glm: 'GLM',
};
/** Options for a model select: the known vocabulary plus the current value when it's an
 * unknown id, so a stored model never renders blank in MUI's Select (which shows nothing
 * for a value with no matching MenuItem). */
export function modelOptions(current) {
    return TASK_MODELS.includes(current) ? TASK_MODELS : [current, ...TASK_MODELS];
}
/** Display label for a model id — known vocabulary gets its friendly name, unknown ids
 * pass through raw. */
export function modelLabel(model) {
    return MODEL_LABELS[model] ?? model;
}
export const SKILL_TYPES = [
    'task-from-slack-app',
    'task-from-github-app',
    'normal-task',
    'task-from-slack-message',
];
/** Skill types that route via a Slack channel — shared by SkillFormModal and SkillSidebar so
 * the two don't drift if a third Slack-routed type is ever added. */
export const SLACK_CHANNEL_SKILL_TYPES = ['task-from-slack-app', 'task-from-slack-message'];
